import { FC } from 'react'

import { CartItemProperties } from '../../../../../types/figs'

import { Container, Property } from './styles'

// NOTE: Shopify refers to custom data on a cart line as "attributes". FIGS has historically called them "properties".
// Relatively interchangeable terms, so I'm leaving them mixed here for the sake of not renaming all types.
export const CartItemAttributes: FC<{
  attributes: CartItemProperties
}> = ({ attributes }) => {
  if (Object.keys(attributes).length === 0) return null

  return (
    <Container>
      {Object.keys(attributes).map(key => (
        <Property key={key}>
          {key}: {attributes[key]}
        </Property>
      ))}
    </Container>
  )
}
